import Base from './base';

class Nav extends Base {
	constructor (el) {
		super(el);

		this.navToggle = document.querySelector('.nav-toggle');
		this.app = document.querySelector('.app');

		this.open = false;
		this.navToggle.addEventListener('click', (e) => this.toggleNav(e));

	}

	toggleNav(e) {
		
		if(this.open) {
			this.app.classList.remove('is-sideOpen');
			e.target.classList.remove('open');
		} else {
			this.app.classList.add('is-sideOpen');
			e.target.classList.add('open');
		}

		this.open = !this.open;

	}

}

export default Nav;
